import { render, staticRenderFns } from "./LegendContent.vue?vue&type=template&id=08d56b5a&scoped=true&"
import script from "./LegendContent.vue?vue&type=script&lang=js&"
export * from "./LegendContent.vue?vue&type=script&lang=js&"
import style0 from "./LegendContent.vue?vue&type=style&index=0&id=08d56b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d56b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
